import React from "react";
import { useTranslation } from "react-i18next";
import { messages } from "../../../locales/messages";
import { CircularProgress } from "@mui/material";
import type { HealthStatisticsResponseDto } from "../../../../typescript-fetch-sdk/api";
import {
  DashboardSection,
  StatsGrid,
  StatCard,
  StatValue,
  StatLabel,
  StatSubtext,
  LoadingContainer,
  EmptyState,
  EmptyStateTitle,
  EmptyStateText,
} from "./styled";

export const Dashboard: React.FC<{
  statistics: HealthStatisticsResponseDto | null;
  loading: boolean;
}> = ({ statistics, loading }) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <DashboardSection>
        <LoadingContainer>
          <CircularProgress size={40} />
        </LoadingContainer>
      </DashboardSection>
    );
  }

  if (!statistics) {
    return (
      <DashboardSection>
        <EmptyState>
          <EmptyStateTitle>
            {t(messages.No_statistics_available())}
          </EmptyStateTitle>
          <EmptyStateText>
            {t(messages.Unable_to_load_health_statistics())}
          </EmptyStateText>
        </EmptyState>
      </DashboardSection>
    );
  }

  return (
    <DashboardSection>
      <StatsGrid>
        <StatCard sx={{ borderColor: "#ff8038" }}>
          <StatValue style={{ borderColor: "#ff8038" }}>
            {statistics?.totalComputers || 0}
          </StatValue>
          <StatLabel>{t(messages.Total_Computers())}</StatLabel>
          <StatSubtext>{t(messages.Registered_in_system())}</StatSubtext>
        </StatCard>
        <StatCard sx={{ borderColor: "#28a745" }}>
          <StatValue style={{ borderColor: "#28a745" }}>
            {statistics?.healthyComputers || 0}
          </StatValue>
          <StatLabel>{t(messages.Healthy())}</StatLabel>
          <StatSubtext>{t(messages.Currently_active())}</StatSubtext>
        </StatCard>{" "}
        <StatCard sx={{ borderColor: "#ffc107" }}>
          <StatValue style={{ borderColor: "#ffc107" }}>
            {statistics?.staleComputers || 0}
          </StatValue>
          <StatLabel>{t(messages.Stale())}</StatLabel>
          <StatSubtext>{t(messages.Not_updated_recently())}</StatSubtext>
        </StatCard>
        <StatCard sx={{ borderColor: "#dc3545" }}>
          <StatValue style={{ borderColor: "#dc3545" }}>
            {statistics?.inactiveComputers || 0}
          </StatValue>
          <StatLabel>{t(messages.Inactive())}</StatLabel>
          <StatSubtext>{t(messages.Not_responding())}</StatSubtext>
        </StatCard>
        <StatCard sx={{ borderColor: "#17a2b8" }}>
          <StatValue style={{ borderColor: "#17a2b8" }}>
            {statistics?.recentlyActive || 0}
          </StatValue>
          <StatLabel>{t(messages.Recently_Active())}</StatLabel>
          <StatSubtext>{t(messages.Active_in_last_24h())}</StatSubtext>
        </StatCard>
      </StatsGrid>
    </DashboardSection>
  );
};
